import { render, staticRenderFns } from "./LpuLogo.vue?vue&type=template&id=7695a30f&scoped=true&"
import script from "./LpuLogo.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuLogo.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuLogo.vue?vue&type=style&index=0&id=7695a30f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7695a30f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7695a30f')) {
      api.createRecord('7695a30f', component.options)
    } else {
      api.reload('7695a30f', component.options)
    }
    module.hot.accept("./LpuLogo.vue?vue&type=template&id=7695a30f&scoped=true&", function () {
      api.rerender('7695a30f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuLogo.vue"
export default component.exports